import { Grid, MenuItem } from '@mui/material';
import TextField from '@mui/material/TextField';
import React from 'react';
import { useDispatch } from 'react-redux';

export interface IFormulaireProps {
    valueEdit: any;
    setValueEdit: any;
    setValueComboEdit?: any;
    valeurComboEdit?: any;
    libelle?: string;
    data?: any;
    libelleCombo?: any
}

const EditForm = (props: IFormulaireProps) => {


    const {
        valueEdit,
        setValueEdit,
        libelle,
    } = props


    const dispatch = useDispatch()

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item md={12} xs={12} sm={12}>
                    <TextField
                        label={libelle ? libelle : "Module"}
                        fullWidth
                        required
                        margin="dense"
                        size="small"
                        type="text"
                        variant="standard"
                        name="valueEdit"
                        value={valueEdit}
                        onChange={(e) => dispatch(setValueEdit(e.target.value))}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

export default EditForm;
